import React from 'react';
import { Line } from 'react-konva';
import { markerTrailLength, PathProps, timestampSearchRange } from 'types/webPlayer';
import { PATH_COLOR, PATH_WIDTH } from '../track/ground/constants';
import { getSinglePlayerPointGPS } from '../utils/groundGbf';

const Path = React.memo((props: PathProps) => {
  const {
    bearing,
    cursor,
    dataGround,
    pathColor,
    pathData,
    scale = 1,
  } = props;

  const paths: number[][] = [[]];
  let lineNumber = 0;
  const isGPS = dataGround?.groundCoordsType === "GLOBAL";

  // @todo ottimizzare per limitarsi al range e poi terminare subito
  Object.keys(pathData).forEach((t) => {
    const timestamp = parseInt(t, 10);
    const values = pathData[t];

    if (timestamp > cursor - markerTrailLength && timestamp < (cursor - timestampSearchRange)) {
      let tmpPoint = values;
      if (isGPS) {
        tmpPoint = getSinglePlayerPointGPS({
          bearing,
          groundData: dataGround,
          point: values
        })
      }

      if (
        !tmpPoint.x || !tmpPoint.y
        || tmpPoint.x === null || tmpPoint.y === null
        || tmpPoint.x === NaN || tmpPoint.y === NaN
      ) {
        lineNumber += 1;
        paths[lineNumber] = [];
      } else {
        paths[lineNumber].push(tmpPoint.x * (isGPS ? scale : scale));
        paths[lineNumber].push(tmpPoint.y * -(isGPS ? -scale : scale));
      }
    }
  });

  return (
    <>
      {
        paths.map((path, idx) => (
          <Line
            /* eslint-disable-next-line react/no-array-index-key */
            key={idx}
            points={path}
            stroke={pathColor || PATH_COLOR}
            strokeWidth={PATH_WIDTH}
          />
        ))
      }
    </>
  );
});

export default Path;
